import SocialLink from '@/view/Social/SocialLink';

export default function YouTube() {
  return (
    <SocialLink
      title="Youtube"
      href="https://www.youtube.com/channel/UCmb9zIvYu4sZmuHUX0aLFEQ"
    >
      <svg
        className="h-auto max-w-full fill-current"
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48"
      >
        <title>YouTube</title>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0ZM34.0016 15.7493C35.1031 16.0516 35.9706 16.9422 36.265 18.0732C36.8 20.123 36.8 24.4 36.8 24.4C36.8 24.4 36.8 28.6768 36.265 30.7268C35.9706 31.8578 35.1031 32.7484 34.0016 33.0508C32.0054 33.6 24 33.6 24 33.6C24 33.6 15.9946 33.6 13.9983 33.0508C12.8967 32.7484 12.0292 31.8578 11.7348 30.7268C11.2 28.6768 11.2 24.4 11.2 24.4C11.2 24.4 11.2 20.123 11.7348 18.0732C12.0292 16.9422 12.8967 16.0516 13.9983 15.7493C15.9946 15.2 24 15.2 24 15.2C24 15.2 32.0054 15.2 34.0016 15.7493Z"
          fill="current"
        />
        <path d="M21.6 28.8V20.8L28 24.8001L21.6 28.8Z" fill="current" />
      </svg>
    </SocialLink>
  );
}
